/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_List_Filters_SubInputs */

const en_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter the Event List by multiple criteria`)
};

const fr_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer la liste d’événements selon plusieurs critères`)
};

const de_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisliste nach mehreren Kriterien filtern`)
};

const it_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtra l'elenco degli eventi in base a più criteri`)
};

const ru_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отфильтруйте список событий по нескольким критериям.`)
};

const es_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar la lista de eventos por múltiples criterios`)
};

const zh_cn2_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按多个条件筛选事件列表`)
};

const ja_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数の基準でイベントリストをフィルタリングする`)
};

const hi_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कई मानदंडों के आधार पर इवेंट सूची को फ़िल्टर करें`)
};

const pt_pt2_event_list_filters_sub = /** @type {(inputs: Event_List_Filters_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar a lista de eventos por múltiplos critérios`)
};

/**
* | output |
* | --- |
* | "Filter the Event List by multiple criteria" |
*
* @param {Event_List_Filters_SubInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_list_filters_sub = /** @type {((inputs?: Event_List_Filters_SubInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_List_Filters_SubInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_list_filters_sub(inputs)
	if (locale === "de") return de_event_list_filters_sub(inputs)
	if (locale === "it") return it_event_list_filters_sub(inputs)
	if (locale === "ru") return ru_event_list_filters_sub(inputs)
	if (locale === "es") return es_event_list_filters_sub(inputs)
	if (locale === "zh-CN") return zh_cn2_event_list_filters_sub(inputs)
	if (locale === "ja") return ja_event_list_filters_sub(inputs)
	if (locale === "hi") return hi_event_list_filters_sub(inputs)
	if (locale === "pt-PT") return pt_pt2_event_list_filters_sub(inputs)
	return en_event_list_filters_sub(inputs)
});